export const routePaths = {
  splashScreen: "/",
  selectLanguage: "/select-language",
  notLivingInCanada: "/profile/not-living-in-canada",
  login: "/login",
  signUp: "/sign-up",
  emailVerified: "/verified-email",
  forgotPassword: "/forget-password",
  resetPassword: "/reset-password",
  verificationCode: "/verification-code",
  getStarted: "/create-profile/get-started",
  onboarding: "/create-profile/about-you",
  income: "/create-profile/income",
  expenses: "/create-profile/expenses",
  report: "/create-profile/report",
  dashboard: "/dashboard",
  budget: "/budget/:id",
  settings: "/settings/*",
  editForm: "edit-form/*",
  termsAndConditions: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",
  notifications: "notifications",
  editProfile: "about-you",
  editIncome: "income",
  editExpenses: "expenses",
  changePassword: "change-password",
  settingsPrivacyPolicy: "privacy-policy",
  settingsTemsNConditions: "terms-and-conditions",
  helpAndSupport: "help-and-support",
  partnersSponsors: "partners-sponsors",
  faqs: "faqs",
  myBudgets: "my-budgets",
  resources: "resources",
};
